/* eslint-disable react/prop-types */
import {
	Autocomplete,
	Box,
	Button,
	CircularProgress,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	Snackbar,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import '../Dashboard.css';
import Schedular from './Schedular';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
	addAppointment,
	getAppointment,
	getLocation,
	getPatientList,
	getPracticeStaff,
	updateAppointment,
} from '../../../services/api/apiManager';

import { useStateValue } from '../../../services/state/State';
import dayjs from 'dayjs';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import {
	Cancel,
	Delete,
	Edit,
	Refresh,
	Update,
	WindowSharp,
} from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { useNavigate } from 'react-router';
const colors = ['#CFECFF', '#403C3C', '#FDF1DB'];

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: 'white',
	fontFamily: 'Poppins',
	borderRadius: '10px',
	width: '70%',
};

function ScheduleAppointment(props) {
	const routerNavigator = useNavigate();

	const [{ patients, locations, practice }, dispatch] = useStateValue();
	const practiceId = localStorage.getItem('practice_id');
	const [invalidInfo, setInvalidInfo] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [updateAppointmentSnackbar, setupdateAppointmentSnackbar] =
		useState(false);
	const [deleteAppointment, setDeleteAppointment] = useState(false);
	const defaultTheme = createTheme();
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [patientList, setPatientList] = useState([]);
	const [filterLocation, setFilterLocation] = React.useState('');
	const [week, setWeek] = React.useState('');
	const [open, setOpen] = React.useState(false);
	const [appointmentList, setAppointmentList] = useState([]);
	const [staffList, setStaffList] = useState([]);
	const [location, setLocation] = useState([]);
	const [provider, setProvider] = React.useState('');
	const [selectedFilterDate, setSelectedFilterDate] = useState(null);
	const [loading, setLoading] = useState(false);
	const practice_id = localStorage.getItem('practice_id');
	const [filteredAppointments, setFilteredAppointments] =
		useState(appointmentList);
	const [rows, setRows] = useState([]);
	const [appointment, setappoitment] = useState({
		// practice_id: practice_id,
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
		Status: '',
		Reason: '',
	});
	// update apppointments states are here
	const [updateDate, setUpdateDate] = useState(dayjs(new Date()));
	const [appointmentID, setAppointmentID] = useState(0);
	const [updateAppointmentData, setUpdateAppointmentData] = useState({
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: '',
		Status: '',
		Reason: '',
	});
	const [updateModalopen, setUpdateModalopen] = React.useState(false);
	const updateModalhandleOpen = (data) => {
		// when modal opening all values will be according to patient appointment
		setUpdateAppointmentData({
			patient_id: data?.row?.patient_id,
			// patient: data?.row?.patient?.name,
			provider_id: data?.row?.provider_id,
			location_id: data?.row?.location_id,
			//because update data is coming from datagrid and date and time values are separated from each other thats why we are using this logic
			AppointmentDate: dayjs(
				dayjs(
					data?.row?.ApptDate + 'T' + data?.row?.ApptTime.slice(0, 8),
					'MM-DD-YYYYTHH:mm:ss'
				).toDate()
			).format('YYYY-MM-DDTHH:mm:ss'),
			Status: data?.row?.Status,
			Reason: data?.row?.Reason,
		});
		setUpdateDate(
			//because update data is coming from datagrid and date and time values are separated from each other thats why we are using this logic
			dayjs(
				dayjs(
					data?.row?.ApptDate + 'T' + data?.row?.ApptTime.slice(0, 8),
					'MM-DD-YYYYTHH:mm:ss'
				)
					.toDate()
					.toString()
			)
		);
		setAppointmentID(data?.row?.id);
		setUpdateModalopen(true);
	};
	const updateModalhandleClose = () => setUpdateModalopen(false);
	// Modal Delete with these state values are shown in delete Modal
	const [openDeleteModal, setOpenDeleteModal] = useState({
		deleteModalOpen: false,
		deletingId: '',
		deletingName: '',
		deletingReason: '',
	});
	const handleOpenDeleteModal = (data) => {
		debugger;
		setOpenDeleteModal({
			deleteModalOpen: true,
			deletingId: data?.row?.id,
			deletingName: data?.row?.name,
			deletingReason: data?.row?.Reason,
		});
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal({
			deleteModalOpen: false,
			deletingId: '',
			deletingName: '',
			deletingReason: '',
		});
	};

	const navigateToPatientPage = (cellValues) => {
		routerNavigator('/Edit_Patient', {
			state: {
				id: cellValues?.row?.patient_id,
				id1: cellValues?.row?.id,
				id2: cellValues?.row?.admissionid,
				id3: cellValues?.row?.LstVistId,
			},
		});
	};

	useEffect(() => {
		// Sort appointments by ID in descending order
		const sortedAppointments = filteredAppointments.sort((a, b) => b.id - a.id);

		// Map appointments to rows
		const appointmentRows = sortedAppointments.map((data) => ({
			id: data.id,
			ApptDate: moment(data.AppointmentDate).format('MM-DD-YYYY'),
			ApptTime: moment(data.AppointmentDate).format('h:mm:ss A'),
			Reason: data.Reason,
			Location: data?.location?.Name,
			location_id: data?.location_id,
			Status: data?.Status,
			patient_id: data.patient_id,
			provider_id: data?.provider_id,
			name: data?.patient?.Lname + ' , ' + data?.patient?.Fname,
			provider: data?.provider?.Lname + ' , ' + data?.provider?.Fname,
		}));

		// Update the rows state
		setRows(appointmentRows);
	}, [filteredAppointments]);

	const columns = [
		{ field: 'id', headerName: 'ID', width: 70 },
		{
			field: 'name',
			headerName: 'Patient Name',
			width: 170,
			renderCell: (cellValues) => {
				return (
					<div>
						<p
							style={{ cursor: 'pointer' }}
							onClick={() => {
								navigateToPatientPage(cellValues);
							}}
						>
							<u>{cellValues.value}</u>&nbsp;
							{/* <Tooltip
								title={
									!cellValues?.row?.Admission_date
										? 'No Admission Created'
										: 'Admission Created'
								}
							>
								<InfoIcon sx={{ fontSize: '16px', color: 'red' }} />
							</Tooltip> */}
						</p>
					</div>
				);
			},
		},
		{
			field: 'provider',
			headerName: 'Provider Name',
			width: 170,
		},
		{
			field: 'ApptDate',
			headerName: 'Appointment Date',
			width: 190,
		},
		{
			field: 'ApptTime',
			headerName: 'Appointment Time',
			width: 190,
			renderCell: (params) => {
				const apptTime_AMPM = params?.value;
				return (
					<>
						<span>{dayjs(apptTime_AMPM, 'HH:mm:ss').format('hh:mm:ss A')}</span>
					</>
				);
			},
		},
		{
			field: 'Reason',
			headerName: 'Reason',
			width: 200,
		},
		{
			field: 'Location',
			headerName: 'Location',
			type: 'number',
			width: 150,
		},
		{
			field: 'Status',
			headerName: 'Status',
			type: 'number',
			width: 100,
			renderCell: (params) => {
				let statusText = '';
				let statusColor = '';

				switch (params.value) {
					case 'P':
						statusText = 'Pending';
						statusColor = '#FEAB13';
						break;
					case 'C':
						statusText = 'Completed';
						statusColor = 'green';
						break;
					case 'D':
						statusText = 'Dismissed';
						statusColor = 'red';
						break;
					case 'O':
						statusText = 'Other';
						statusColor = 'black';
						break;
					default:
						break;
				}

				return <span style={{ color: statusColor }}>{statusText}</span>;
			},
		},
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'Actions',
			headerName: 'Actions',
			type: 'number',
			width: 150,
			renderCell: (rows) => {
				return (
					<div>
						<IconButton
							onClick={() => {
								updateModalhandleOpen(rows);
							}}
							sx={{
								cursor: 'pointer',
								color: '#0e4374',
								fontSize: '20px',
							}}
						>
							<EditIcon fontSize="small" />
						</IconButton>
						<IconButton
							onClick={() => {
								handleOpenDeleteModal(rows);
							}}
							sx={{
								cursor: 'pointer',
								color: 'red',
								fontSize: '20px',
							}}
						>
							<DeleteIcon fontSize="small" />
						</IconButton>
					</div>
				);
			},
		},
	];
	// ROWS DATA for DATAGRID
	const rows1 =
		filteredAppointments &&
		filteredAppointments.map((data, index) => ({
			id: data.id,
			ApptDate: moment(data.AppointmentDate).format('MM-DD-YYYY'),
			ApptTime: dayjs(data.AppointmentDate).format('HH:mm:ss'),
			Reason: data.Reason,
			Location: data?.location?.Name,
			location_id: data?.location_id,
			Status: data?.Status,
			patient_id: data.patient_id,
			provider_id: data?.provider_id,
			name: data?.patient?.Lname + ' , ' + data?.patient?.Fname,
			provider: data?.provider?.Lname + ' , ' + data?.provider?.Fname,
		}));

	const handleProvider = (event) => {
		setProvider(event.target.value);

		const filterAppointmentss = appointmentList?.filter((appointment) => {
			if (
				filterLocation === '' &&
				selectedFilterDate === null &&
				event.target.value !== ''
			) {
				return appointment.provider_id === parseInt(event.target.value);
			} else if (
				event.target.value === '' &&
				selectedFilterDate === null &&
				filterLocation !== ''
			) {
				return appointment?.location_id === parseInt(filterLocation);
			} else if (
				event.target.value !== '' &&
				filterLocation !== '' &&
				selectedFilterDate === null
			) {
				return (
					appointment.provider_id === parseInt(event.target.value) &&
					appointment.location_id === parseInt(filterLocation)
				);
			} else if (
				filterLocation === '' &&
				event.target.value !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(event.target.value) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (
				filterLocation !== '' &&
				event.target.value !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(event.target.value) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(filterLocation)
				);
			} else if (
				event.target.value === '' &&
				filterLocation === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
					selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (
				event.target.value === '' &&
				filterLocation !== '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(filterLocation)
				);
			} else if (event.target.value === '' && filterLocation === '') {
				return appointmentList;
			}
		});
		setFilteredAppointments(filterAppointmentss);
	};

	const handleCloseSnackbar = () => setOpenSnackbar(false);
	const handleFilterLocation = (e) => {
		setFilterLocation(e.target.value);
		const filterAppointmentss = appointmentList?.filter((appointment) => {
			if (
				provider === '' &&
				selectedFilterDate === null &&
				e.target.value !== ''
			) {
				return appointment?.location_id === parseInt(e.target.value);
			} else if (
				e.target.value === '' &&
				selectedFilterDate === null &&
				provider !== ''
			) {
				return appointment?.provider_id === parseInt(provider);
			} else if (
				e.target.value !== '' &&
				provider !== '' &&
				selectedFilterDate === null
			) {
				return (
					appointment?.location_id === parseInt(e.target.value) &&
					appointment?.provider_id === parseInt(provider)
				);
			} else if (
				e.target.value !== '' &&
				provider === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(e.target.value)
				);
			} else if (
				e.target.value !== '' &&
				provider !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(provider) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(e.target.value)
				);
			} else if (
				e.target.value === '' &&
				provider === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
					selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (e.target.value === '' && provider === '') {
				return appointmentList;
			}
		});

		setFilteredAppointments(filterAppointmentss);
	};

	const handleDateChange = (date) => {
		const dataSelect = date;
		setSelectedFilterDate(dataSelect);

		const filterAppointments = dataSelect
			? appointmentList?.filter((appointment) => {
					if (provider !== '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return (
							formattedAppointmentDate === dataSelect.format('YYYY-MM-DD') &&
							appointment?.provider_id === parseInt(provider)
						);
					} else if (filterLocation !== '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return (
							formattedAppointmentDate === dataSelect.format('YYYY-MM-DD') &&
							appointment?.location_id === parseInt(filterLocation)
						);
					} else if (provider === '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return formattedAppointmentDate === dataSelect.format('YYYY-MM-DD');
					}
				})
			: appointmentList;

		setFilteredAppointments(filterAppointments);
	};

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocation(resp?.data);
		}
	};
	const fetchAppointments = async () => {
		setLoading(true);
		const res = await getAppointment();
		if (res?.status === 200) {
			// setAppointmentList(res?.data);
			setAppointmentList(
				res?.data?.filter((items) => items?.patient?.practice_id == practiceId)
			);
		} else if (res?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
		setLoading(false);
	};

	const fetchPatientList = async (id) => {
		const resp = await getPatientList(id);
		if (resp.status === 200) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	const fetchPracticeStaff = async () => {
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};
	// for adding new appointments
	const addNewAppointment = async (data) => {
		const resp = await addAppointment(data);
		if (resp.status === 201) {
			setPostSucessfully(true);
			setOpenSnackbar(true);
			handleCloseModal();
			setappoitment({
				patient_id: '',
				provider_id: '',
				AppointmentDate: dayjs(selectedDate),
				Status: 'P',
				location_id: '',
				Reason: '',
			});
			fetchAppointments();
			setselectedDate(dayjs(new Date()));
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	// for updating appointment
	const updateAppointmentInfo = async (id, data) => {
		const resp = await updateAppointment(id, data);
		if (resp?.status === 200) {
			setPostSucessfully(true);
			updateModalhandleClose();
			setupdateAppointmentSnackbar(true);
			if (resp?.data?.Deleted === true) {
				setDeleteAppointment(true);
				setOpenDeleteModal(false);
			}
			setOpenSnackbar(true);
			fetchAppointments();
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
		setSelectedFilterDate(null);
		setProvider('');
		setFilterLocation('');
	};

	const mappingPatientsList =
		patients &&
		patients?.map((row) => ({
			patientId: row.patient_id,
			patientName: row.Name,
		}));

	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row?.Lname + ' ' + row?.Fname,
			providerId: row.id,
		}));

	const handleOpen = () => setOpen(true);
	const handleCloseModal = () => {
		setappoitment({
			patient_id: '',
			provider_id: '',
			AppointmentDate: dayjs(selectedDate),
			location_id: '',
			Status: 'P',
			Reason: '',
		});
		setOpen(false);
	};

	useEffect(() => {
		fetchAppointments();
		getLocationsData();
		fetchPatientList(practiceId);
		fetchPracticeStaff();
	}, []);

	useEffect(() => {
		if (appointmentList) {
			setFilteredAppointments(appointmentList);
		}
	}, [appointmentList]);

	const handleReset = () => {
		setProvider('');
		setFilterLocation('');
		setSelectedFilterDate(null);
		setFilteredAppointments(appointmentList);
	};
	useEffect(() => {
		fetchAppointments();
	}, [props?.reRenderFromParent]);
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid container component="main">
				{loading ? ( // Display loading indicator if loading is true
					<div
						style={{
							width: '100%',
							height: '80vh',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<div className="logo-container">
							<img className="logo" src={WebLogo} alt="Website Logo" />
						</div>
					</div>
				) : (
					<Grid
						item
						container
						xs={12}
						lg={12}
						xl={12}
						md={12}
						sm={12}
						// sx={{ padding: ' 0px 10px 0px 0px' }}
					>
						<Grid
							item
							container
							xs={12}
							lg={12}
							xl={12}
							md={12}
							sm={12}
							sx={{ dislay: 'flex', flexDirection: 'column' }}
						>
							<Grid
								container
								item
								sx={{
									padding: '2px 20px 2px 2px',
									background: 'white',
									// border: '1px solid #CFCACA',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
									xl={3}
									lg={3}
									sx={{ padding: '12px 4px 4px 4px' }}
								>
									<Box>
										<FormControl
											htmlFor="providerFilterID"
											size="small"
											fullWidth
										>
											<InputLabel
												id="providerFilterID"
												sx={{
													fontSize: '15px',
												}}
											>
												Provider
											</InputLabel>
											<Select
												defaultValue=""
												name="providerFilter"
												value={provider}
												onChange={handleProvider}
												label="Provider"
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													borderLeft: '5px solid #DA8541',
													borderRadius: '4px',

													'&.MuiInput-underline:before': {
														borderBottom: 'none',
													},
													'&.Mui-focused': {
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
													},
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
												MenuProps={{
													PaperProps: {
														style: {
															width: '7.3%',
															height: '18%',
															overflowY: 'scroll',
															overflowX: 'scroll',
														},
													},
												}}
											>
												<MenuItem value="">Clear Filter</MenuItem>
												{mappingProviderList &&
													mappingProviderList.length > 0 &&
													mappingProviderList.map((pl, index) => (
														<MenuItem key={index} value={pl.providerId}>
															{pl?.name}
														</MenuItem>
													))}
											</Select>
										</FormControl>
									</Box>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
									xl={3}
									lg={3}
									sx={{ padding: '12px 4px 4px 4px' }}
								>
									<Box>
										<FormControl
											size="small"
											fullWidth
											inputProps={{ 'aria-label': 'Without label' }}
										>
											<InputLabel
												id="locationFilterID"
												sx={{
													fontSize: '15px',
												}}
											>
												Location
											</InputLabel>
											<Select
												defaultValue=""
												name="locationFilterID"
												label="Provider"
												inputProps={{ 'aria-label': 'Without label' }}
												MenuProps={{
													PaperProps: {
														style: {
															width: '7.3%',
															height: '18%',
															overflowY: 'scroll',
															overflowX: 'scroll',
														},
													},
												}}
												value={filterLocation}
												onChange={handleFilterLocation}
												sx={{
													borderLeft: '5px solid #DA8541',
													borderRadius: '4px',
													// height: '50px',

													'&.MuiInput-underline:before': {
														borderBottom: 'none',
													},
													'&.Mui-focused': {
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
													},
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">Clear Filter</MenuItem>
												{location?.map((items, index) => {
													return (
														<MenuItem key={index} value={items?.id}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
								</Grid>
								<Grid
									item
									xs={6}
									sm={4}
									md={4}
									xl={4}
									lg={4}
									sx={{ paddingLeft: '4px' }}
								>
									<Box sx={{ display: 'flex', alignItems: 'center' }}>
										<LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
											<DemoContainer components={['DatePicker']}>
												<DemoItem>
													<DatePicker
														label="Date"
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															width: '100%',
															'.css-4jnixx-MuiStack-root': {
																paddingTop: '0px',
															},
														}}
														slotProps={{ textField: { size: 'small' } }}
														value={selectedFilterDate}
														onChange={handleDateChange}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
										<Tooltip title="Reset Filters" placement="right">
											<Button
												onClick={handleReset}
												variant="contained"
												color="success"
												size="medium"
												sx={{
													marginLeft: '10px',

													marginTop: '8px',
												}}
											>
												<Refresh />
											</Button>
										</Tooltip>
									</Box>
								</Grid>
								<Grid
									item
									xs={6}
									sm={2}
									md={2}
									xl={2}
									lg={2}
									sx={{
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
									}}
								>
									<Button
										onClick={handleOpen}
										startIcon={<PersonAddIcon />}
										sx={{
											// height: '30px',
											color: 'white',

											background: '#FD7702',
											fontWeight: '500',
											fontFamily: 'Poppins',
											'&:hover': {
												border: '#FD7702',
												color: '#FD7702',
												background: 'white',
											},
										}}
									>
										Add
									</Button>
								</Grid>
							</Grid>
						</Grid>

						<Box
							sx={{
								height: {
									xl: '75vh',
									lg: '65vh',
									md: '65vh',
								},
								width: {
									xl: '99%',
									lg: '93vw',
									md: '92.5vw',
									sm: '89vw',
									xs: '350px',
								},
								overflow: 'visible',
								// '@media screen and (min-device-width: 900px) and (max-device-width: 1000px)':
								// 	{
								// 		/* STYLES HERE */
								// 		width: '80%',
								// 	},
							}}
						>
							{' '}
							<DataGrid
								rows={rows1}
								columns={columns}
								rowHeight={35}
								columnHeaderHeight={35}
								initialState={{
									pagination: {
										paginationModel: {
											pageSize: 10,
										},
									},
								}}
								pageSizeOptions={[5, 10, 50, 100]}
								disableRowSelectionOnClick
								sx={{
									'& .MuiDataGrid-columnHeaders': {
										backgroundColor: '#0D406F',
										color: '#FFFFFF',
										fontFamily: 'Poppins',
										fontWeight: '300',
										fontSize: {
											xl: '15px',
											lg: '13px',
											md: '13px',
											sm: '13px',
											xs: '13px',
										},
										overflow: 'hidden',
										'.MuiSvgIcon-root': {
											color: 'white',
										},
									},
								}}
							/>{' '}
						</Box>
					</Grid>
				)}
				{/* add appointment */}
				<Modal
					open={open}
					onClose={handleCloseModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							width={'100%'}
							display={'flex'}
							alignItems={'center'}
							justifyContent={'flex-end'}
							bgcolor={'#0e4374'}
							height={'30px'}
							p={0}
							borderRadius={'10px 10px 0 0 '}
						>
							<Cancel
								sx={{ cursor: 'pointer', color: 'whitesmoke' }}
								onClick={() => {
									handleCloseModal();
									setInvalidInfo(false);
									setappoitment({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
							/>
						</Box>
						{invalidInfo && (
							<Box
								display={
									appointment?.patient_id === ''
										? ''
										: appointment?.provider_id === ''
											? ''
											: appointment?.Status === ''
												? ''
												: appointment?.Reason === ''
													? ''
													: appointment?.AppointmentDate == 'Invalid Date'
														? ''
														: appointment?.location_id === ''
															? ''
															: 'none'
								}
							>
								<Alert variant="filled" severity="error">
									Please Fill all Information!
								</Alert>
							</Box>
						)}
						<Typography
							id="modal-modal-title"
							variant="h6"
							component="h2"
							sx={{
								textAlign: 'center',
								fontWeight: '500',
								fontFamily: 'Poppins',
							}}
						>
							Add Appointment
						</Typography>
						<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
							<Grid container item xs={12} sm={12} md={6} lg={6} xl={6}>
								<Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
									<Grid
										item
										xs={12}
										lg={12}
										md={12}
										sm={12}
										xl={12}
										sx={{
											padding: ' 3px 13px',
										}}
									>
										<Typography
											variant="body1"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
											}}
										>
											Select Patient
										</Typography>
										<FormControl
											fullWidth
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
												borderRadius: '4px',
											}}
										>
											{/* <Select
												defaultValue=""
												MenuProps={{
													PaperProps: {
														style: {
															width: '8.3%',
															height: '18%',
															overflowY: 'scroll',
															overflowX: 'scroll',
														},
													},
												}}
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												placeholder="Add Patient"
												value={appointment?.patient_id}
												onChange={(e) => {
													setappoitment((prev) => ({
														...prev,
														patient_id: e.target.value,
														provider_id: (patientList?.filter(
															(items) => items?.patient_id === e.target.value
														))[0]?.providerid,
														location_id: (patientList?.filter(
															(items) => items?.patient_id === e.target.value
														))[0]?.locationid,
													}));
												}}
											>
												<MenuItem value={''}>Patients</MenuItem>
												{patientList?.map((items, index) => (
													<MenuItem
														key={index}
														value={items?.patient_id}
														// style={{ width: '100%' }}
													>
														{items?.Name}
													</MenuItem>
												))}
											</Select> */}
											<Autocomplete
												id="patient"
												name="patient"
												disableClearable
												options={patientList}
												getOptionLabel={(optionsParam) => {
													return optionsParam?.Name;
												}}
												onChange={(event, optionsParam) => {
													setappoitment((prev) => ({
														...prev,
														patient_id: optionsParam?.patient_id,
														provider_id: (patientList?.filter(
															(items) =>
																items?.patient_id === optionsParam?.patient_id
														))[0]?.providerid,
														location_id: (patientList?.filter(
															(items) =>
																items?.patient_id === optionsParam?.patient_id
														))[0]?.locationid,
													}));
												}}
												renderInput={(params) => (
													<TextField
														// error={practice === '' && validationErrors}
														// helperText={
														// 	practice === '' && validationErrors
														// 		? '*patient must be select'
														// 		: ''
														// }
														name="patient"
														{...params}
														InputProps={{
															...params.InputProps,
															type: 'search',
															size: 'small',

															sx: {
																height: '42px',
																color: '#000',
																borderRadius: '6px',
																'&.Mui-focused .MuiOutlinedInput-notchedOutline':
																	{
																		borderColor: '#0E6368',
																	},
																'& .MuiSvgIcon-root': {
																	color: '#353C40',
																	fontSize: '30px',
																},
																'& .MuiOutlinedInput-input': {
																	padding: '8.5px 5px',
																},
															},
														}}
													/>
												)}
											/>
										</FormControl>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={11}
									lg={11}
									xl={11}
									sx={{
										padding: '8px 13px',
									}}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Reason
									</Typography>
									<TextField
										multiline
										fullWidth
										name="Reason"
										rows={3}
										sx={{
											borderRadius: '6px',
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
										}}
										value={appointment?.Reason}
										onChange={(e) =>
											setappoitment((prev) => ({
												...prev,
												Reason: e.target.value,
											}))
										}
									/>
								</Grid>
							</Grid>

							<Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Provider Name
									</Typography>
									<FormControl
										fullWidth
										name="providerId"
										sx={{
											borderRadius: '6px',
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											'& .MuiOutlinedInput-input': {
												padding: '9px 0px 9px 6px',
											},
										}}
									>
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '18%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											placeholder="Select Provider Name"
											value={appointment?.provider_id}
											onChange={(e) =>
												setappoitment((prev) => ({
													...prev,
													provider_id: e.target.value,
												}))
											}
										>
											<MenuItem value={0} style={{ width: '100%' }} disabled>
												Provider
											</MenuItem>
											{mappingProviderList &&
												mappingProviderList.length > 0 &&
												mappingProviderList.map((item, index) => (
													<MenuItem
														key={index}
														value={item?.providerId}
														style={{ width: '100%' }}
													>
														{item?.name}
													</MenuItem>
												))}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Appointment Status
									</Typography>

									<FormControl fullWidth>
										<Select
											defaultValue=""
											labelId="Status"
											id="Status"
											value={appointment?.Status}
											name="Status"
											onChange={(e) => {
												setappoitment((prev) => ({
													...prev,
													Status: e.target.value,
												}));
											}}
											sx={{
												height: '40px',
												width: '100%',
												borderRadius: '6px',
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
												'& .MuiOutlinedInput-input': {
													padding: '9px 0px 9px 6px',
												},
											}}
										>
											<MenuItem value={'C'}>Completed</MenuItem>
											<MenuItem value={'D'}>Dismissed</MenuItem>
											<MenuItem value={'O'}>Other</MenuItem>
											<MenuItem value={'P'}>Pending</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Location
									</Typography>
									<FormControl fullWidth>
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '15%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="modallocation"
											id="modallocation"
											value={appointment?.location_id}
											name="modallocation"
											sx={{ height: '45px', mt: 1 }}
											onChange={(e) => {
												setappoitment((prev) => ({
													...prev,
													location_id: e.target.value,
												}));
											}}
										>
											{location?.map((items, index) => {
												return (
													<MenuItem key={index} value={items?.id}>
														{items?.Name}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Appointment Date Time
									</Typography>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DemoContainer components={['DateTimePicker']}>
											<DemoItem>
												<DateTimePicker
													orientation="portrait"
													disablePast
													size="small"
													slotProps={{ textField: { size: 'small' } }}
													sx={{
														boxShadow: '1px 1px 10px #79ACF178 inset',
														width: '100%',
													}}
													value={selectedDate}
													onChange={(nValue) => {
														setselectedDate(nValue);
														setappoitment((prev) => ({
															...prev,
															AppointmentDate: dayjs(nValue).format(
																'YYYY-MM-DDTHH:mm:ss'
															),
														}));
													}}
												/>
											</DemoItem>
										</DemoContainer>
									</LocalizationProvider>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '5px',
								padding: '13px 8px 0px 8px',
							}}
							xs={12}
						>
							<Button
								onClick={() => {
									handleCloseModal();
									setInvalidInfo(false);
									setappoitment({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(new Date()),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
									setselectedDate(dayjs(new Date()));
								}}
								sx={{
									mb: 1,
									background: '#ED2828',
									border: '2px solid #ED2828',
									color: 'white',
									fontFamily: 'Poppins',
									fontSize: '15px',
									fontWeight: '500',
									padding: '7px 15px',
									'&:hover': {
										border: '2px solid #ED2828',
										color: '#ED2828',
									},
								}}
							>
								Cancel
							</Button>

							<Button
								// disabled={
								// 	appointment?.patient_id === ''
								// 		? true
								// 		: appointment?.provider_id === ''
								// 			? true
								// 			: appointment?.Status === ''
								// 				? true
								// 				: appointment?.Reason === ''
								// 					? true
								// 					: appointment?.AppointmentDate == 'Invalid Date'
								// 						? true
								// 						: appointment?.location_id === ''
								// 							? true
								// 							: false
								// }
								sx={{
									mb: 1,
									background: '#FD7702',
									border: '2px solid #e87511',
									color: 'white',
									fontFamily: 'Poppins',
									fontSize: '15px',
									fontWeight: '500',
									padding: '7px 15px',
									'&:hover': {
										border: '2px solid #e87511',
										color: '#e87511',
									},
								}}
								onClick={() => {
									if (
										appointment?.patient_id === '' ||
										appointment?.provider_id === '' ||
										appointment?.Status === '' ||
										appointment?.Reason === '' ||
										appointment?.AppointmentDate == 'Invalid Date' ||
										appointment?.location_id === ''
									) {
										setInvalidInfo(true);
									} else {
										addNewAppointment(appointment);
									}
								}}
							>
								Add Appointment
							</Button>
						</Grid>
					</Box>
				</Modal>

				{/* update Modal for parent component is here */}

				<Modal
					open={updateModalopen}
					onClose={updateModalhandleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							width={'100%'}
							display={'flex'}
							alignItems={'center'}
							justifyContent={'flex-end'}
							bgcolor={'#0e4374'}
							height={'30px'}
							p={0}
							borderRadius={'10px 10px 0 0 '}
						>
							<Cancel
								sx={{ cursor: 'pointer', color: 'whitesmoke' }}
								onClick={() => {
									updateModalhandleClose();
									setUpdateAppointmentData({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
							/>
						</Box>
						{
							// <Box
							// 	display={
							// 		updateAppointmentData?.patient_id === ''
							// 			? ''
							// 			: updateAppointmentData?.provider_id === ''
							// 				? ''
							// 				: updateAppointmentData?.Status === ''
							// 					? ''
							// 					: updateAppointmentData?.Reason === ''
							// 						? ''
							// 						: updateAppointmentData?.location_id === ''
							// 							? ''
							// 							: updateAppointmentData?.AppointmentDate ==
							// 								  'Invalid Date'
							// 								? ''
							// 								: 'none'
							// 	}
							// >
							// 	<Alert variant="filled" severity="error">
							// 		Please Fill all Information!
							// 	</Alert>
							// </Box>
						}
						<Typography
							id="modal-modal-title"
							variant="h6"
							component="h2"
							sx={{
								textAlign: 'center',
								fontWeight: '500',
								fontFamily: 'Poppins',
							}}
						>
							Update Appointment
						</Typography>
						<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
							<Grid container item xs={12} sm={12} md={6} lg={6} xl={6}>
								<Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
									<Grid
										item
										xs={12}
										lg={12}
										md={12}
										sm={12}
										xl={12}
										sx={{
											padding: ' 3px 13px',
										}}
									>
										<Typography
											variant="body1"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
											}}
										>
											Select Patient
										</Typography>
										<FormControl
											size="small"
											fullWidth
											sx={{
												border: '1px solid #00000026',
												borderRadius: '4px',
											}}
										>
											{/* <Select
												defaultValue=""
												MenuProps={{
													PaperProps: {
														style: {
															width: '8.3%',
															height: '18%',
															overflowY: 'scroll',
															overflowX: 'scroll',
														},
													},
												}}
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												placeholder="Add Patient"
												value={updateAppointmentData?.patient_id}
												onChange={(e) => {
													setUpdateAppointmentData((prev) => ({
														...prev,
														patient_id: e.target.value,
													}));
												}}
											>
												<MenuItem value={''}>Patients</MenuItem>
												{patientList?.map((items, index) => (
													<MenuItem
														key={index}
														value={items?.patient_id}
														// style={{ width: '100%' }}
													>
														{items?.Name}
													</MenuItem>
												))}
											</Select> */}
											{patientList?.length > 0 && (
												<Autocomplete
													id="patient"
													name="patient"
													disableClearable
													options={patientList}
													getOptionLabel={(optionsParam) => {
														return optionsParam?.Name;
													}}
													onChange={(event, optionsParam) => {
														setUpdateAppointmentData((prev) => ({
															...prev,
															patient_id: optionsParam?.patient_id,
														}));
													}}
													defaultValue={patientList?.find(
														(items) =>
															items?.patient_id ===
															updateAppointmentData?.patient_id?.toString()
													)}
													renderInput={(params) => (
														<TextField
															name="patient"
															{...params}
															InputProps={{
																...params.InputProps,
																type: 'search',
																size: 'small',

																sx: {
																	height: '42px',
																	color: '#000',
																	borderRadius: '6px',
																	'&.Mui-focused .MuiOutlinedInput-notchedOutline':
																		{
																			borderColor: '#0E6368',
																		},
																	'& .MuiSvgIcon-root': {
																		color: '#353C40',
																		fontSize: '30px',
																	},
																	'& .MuiOutlinedInput-input': {
																		padding: '8.5px 5px',
																	},
																},
															}}
														/>
													)}
												/>
											)}
										</FormControl>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={11}
									lg={11}
									xl={11}
									sx={{
										padding: '8px 13px',
									}}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Reason
									</Typography>
									<TextField
										multiline
										fullWidth
										name="Reason"
										rows={3}
										sx={{
											borderRadius: '6px',
											border: '1px solid #00000026',
										}}
										value={updateAppointmentData?.Reason}
										onChange={(e) =>
											setUpdateAppointmentData((prev) => ({
												...prev,
												Reason: e.target.value,
											}))
										}
									/>
								</Grid>
							</Grid>

							<Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Appointment Date Time
									</Typography>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DemoContainer components={['DateTimePicker']}>
											<DemoItem>
												<MobileDateTimePicker
													disablePast
													size="small"
													slotProps={{ textField: { size: 'small' } }}
													sx={{
														width: '100%',
													}}
													value={updateDate}
													onChange={(nValue) => {
														setUpdateDate(nValue);
														setUpdateAppointmentData((prev) => ({
															...prev,
															AppointmentDate: dayjs(nValue).format(
																'YYYY-MM-DDTHH:mm:ss'
															),
														}));
													}}
												/>
											</DemoItem>
										</DemoContainer>
									</LocalizationProvider>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Location
									</Typography>
									<FormControl fullWidth size="small">
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '15%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="modallocation"
											id="modallocation"
											value={updateAppointmentData?.location_id}
											name="modallocation"
											sx={{ height: '45px', mt: 1 }}
											onChange={(e) => {
												setUpdateAppointmentData((prev) => ({
													...prev,
													location_id: e.target.value,
												}));
											}}
										>
											{location?.map((items, index) => {
												return (
													<MenuItem key={index} value={items?.id}>
														{items?.Name}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Provider Name
									</Typography>
									<FormControl
										size="small"
										fullWidth
										name="providerId"
										sx={{
											borderRadius: '6px',
											'& .MuiOutlinedInput-input': {
												padding: '9px 0px 9px 6px',
											},
										}}
									>
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '18%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											placeholder="Select Provider Name"
											value={updateAppointmentData?.provider_id}
											onChange={(e) =>
												setUpdateAppointmentData((prev) => ({
													...prev,
													provider_id: e.target.value,
												}))
											}
										>
											<MenuItem value={0} style={{ width: '100%' }} disabled>
												Provider
											</MenuItem>
											{mappingProviderList &&
												mappingProviderList.length > 0 &&
												mappingProviderList.map((item, index) => (
													<MenuItem
														key={index}
														value={item?.providerId}
														style={{ width: '100%' }}
													>
														{item?.name}
													</MenuItem>
												))}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={5.5}
									lg={5.5}
									xl={5.5}
									sx={{ margin: '5px' }}
								>
									<Typography
										variant="body2"
										sx={{
											color: '#333',
											fontSize: '14px',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										Appointment Status
									</Typography>

									<FormControl fullWidth size="small">
										<Select
											defaultValue=""
											labelId="Status"
											id="Status"
											value={updateAppointmentData?.Status}
											name="Status"
											onChange={(e) => {
												setUpdateAppointmentData((prev) => ({
													...prev,
													Status: e.target.value,
												}));
											}}
											sx={{
												width: '100%',
												borderRadius: '6px',
												'& .MuiOutlinedInput-input': {
													padding: '9px 0px 9px 6px',
												},
											}}
										>
											<MenuItem value={'C'}>Completed</MenuItem>
											<MenuItem value={'D'}>Dismissed</MenuItem>
											<MenuItem value={'O'}>Other</MenuItem>
											<MenuItem value={'P'}>Pending</MenuItem>
										</Select>
									</FormControl>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '5px',
								padding: '13px 8px 0px 8px',
							}}
							xs={12}
						>
							<Button
								onClick={() => {
									updateModalhandleClose();
									setUpdateAppointmentData({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
								sx={{
									mb: 1,
									background: '#ED2828',
									border: '2px solid #ED2828',
									color: 'white',
									fontFamily: 'Poppins',
									fontSize: '15px',
									fontWeight: '500',
									padding: '7px 15px',
									'&:hover': {
										border: '2px solid #ED2828',
										color: '#ED2828',
									},
								}}
							>
								Cancel
							</Button>

							<Button
								disabled={
									updateAppointmentData?.patient_id === ''
										? true
										: updateAppointmentData?.provider_id === ''
											? true
											: updateAppointmentData?.Status === ''
												? true
												: updateAppointmentData?.Reason === ''
													? true
													: // : updateAppointmentData?.location_id === ''
														// 	? true
														// 	: updateAppointmentData?.AppointmentDate ==
														// 		  'Invalid Date'
														// 		? true
														false
								}
								sx={{
									mb: 1,
									background: '#FD7702',
									border: '2px solid #e87511',
									color: 'white',
									fontFamily: 'Poppins',
									fontSize: '15px',
									fontWeight: '500',
									padding: '7px 15px',
									'&:hover': {
										border: '2px solid #e87511',
										color: '#e87511',
									},
								}}
								onClick={() => {
									updateAppointmentInfo(appointmentID, updateAppointmentData);
								}}
							>
								Update Appointment
							</Button>
						</Grid>
					</Box>
				</Modal>

				{/* Delete Modal */}
				<Modal
					sx={{
						width: '60%',
						top: '20%',
						left: '25%',

						// transform: 'translate(-50%, -50%)',
					}}
					open={openDeleteModal?.deleteModalOpen}
					onClose={handleCloseDeleteModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							width={'100%'}
							display={'flex'}
							alignItems={'center'}
							justifyContent={'flex-end'}
							bgcolor={'#0e4374'}
							height={'30px'}
							p={0}
							borderRadius={'5px 5px 0 0 '}
						>
							<Cancel
								sx={{ cursor: 'pointer', color: 'whitesmoke' }}
								onClick={() => {
									handleCloseDeleteModal();
								}}
							/>
						</Box>
						<Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
							<Typography
								id="modal-modal-title"
								variant="body2"
								align="center"
								fontWeight={500}
							>
								Are You Sure To Delete Appointment of{' '}
								<span style={{ color: '#2081B8' }}>
									{openDeleteModal?.deletingName}
								</span>
								?
							</Typography>
							<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
								<Button
									variant="contained"
									sx={{
										mb: 1,
										bgcolor: '#ED2828',
										// width: '100px',
										// py: '5px',
									}}
									onClick={handleCloseDeleteModal}
								>
									No
								</Button>
								<Button
									variant="contained"
									sx={{
										mb: 1,
										bgcolor: '#FD7702',
										// width: '100px',
										// py: '5px',
									}}
									onClick={() => {
										updateAppointmentInfo(openDeleteModal?.deletingId, {
											Deleted: true,
										});
									}}
								>
									Yes
								</Button>
							</Box>
						</Box>
					</Box>
				</Modal>

				{/* SnackBar */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={1800}
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity={!postSucessfully ? 'error' : 'success'}
						variant="filled"
						sx={{
							width: '100%',
							height: '3.5rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={handleCloseSnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{!postSucessfully ? 'Error!' : 'Appointment Added Successfully!'}
					</Alert>
				</Snackbar>

				{/* Child Component SnackBar that showing on update of Appointment */}
				<Snackbar
					open={updateAppointmentSnackbar}
					autoHideDuration={1800}
					onClose={() => {
						setupdateAppointmentSnackbar(false);
					}}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={() => {
							setupdateAppointmentSnackbar(false);
						}}
						severity={'success'}
						variant="filled"
						sx={{
							width: '100%',
							height: '3.5rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={() => setupdateAppointmentSnackbar(false)}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{deleteAppointment
							? `Appointment Deleted Successfully!`
							: `Appointment Updated Successfully!`}
					</Alert>
				</Snackbar>
			</Grid>
		</ThemeProvider>
	);
}

export default ScheduleAppointment;
